import { getIutkCookie } from './getIutkCookie';
import { setIutkCookie } from './setIutkCookie';
export const ANONYMOUS_IUTK = '00000000-0000-0000-0000-000000000000';
export let iutk = null;
export function determineIutk() {
    if (iutk === null) {
        let iutkCookie;
        try {
            iutkCookie = getIutkCookie();
            if (iutkCookie === null) {
                setIutkCookie();
                iutkCookie = getIutkCookie();
            }
        }
        catch {
            iutkCookie = null;
        }
        if (iutkCookie === null) {
            iutk = ANONYMOUS_IUTK;
        }
        else {
            iutk = iutkCookie;
        }
    }
    return iutk;
}
